export default __webpack_public_path__ + "_/images/bonuses/header/coin-f31928f29adbebf87d4308ba43f2f09892cd40a557195ea659fb0f2657076912.png";